import React from 'react'

import q from 'q'

import {
    _postRetrieveTopBrandsFromCategory
} from '../../../../services'

import { connect } from 'react-redux'

import {
    setBrands
} from '../../actions'

import {
    Row,
    Col,
    Modal,
    Button,
    Checkbox,
    message
} from 'antd'

class BrandsSelectorModal extends React.Component {

    state = {
        categoriesWithTopBrands: []
    }

    render(){

        const { 
            categoriesWithTopBrands
        } = this.state

        const {
            brands
        } = this.props

        return (
            <Modal
                bodyStyle={{
                    maxHeight: 600,
                    overflowY: 'scroll'
                }}
                footer={
                    <Row 
                    justify="space-between"
                    type="flex">
                        <Col>
                            {brands.length} brands selected
                        </Col>
                        <Col>
                            <Button onClick={this.props.onCancel}>Ok</Button>
                        </Col>
                    </Row>
                }
                centered
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                afterClose={this.props.afterClose}
            >
                {categoriesWithTopBrands.map( _categoryWithTopBrands => {

                    return (
                        <div style={{marginBottom: 24}}>
                            <div>
                                <h3>{_categoryWithTopBrands.title}</h3>
                            </div>
                            <Row 
                            gutter={12}
                            type="flex">
                                {_categoryWithTopBrands.topBrands.map( (_topBrand, index) => {

                                    return (
                                        <Col style={{ marginBottom: 16 }}>
                                            <Checkbox 
                                            onChange={()=>this.handleCheck({
                                                kebabName: _topBrand.kebabName,
                                                url: _topBrand.image.url
                                            })}
                                            checked={brands.filter( _brand => _brand.kebabName === _topBrand.kebabName).length > 0}
                                            value={_topBrand.kebabName}>
                                                {_topBrand.name} (Rank {index + 1})
                                            </Checkbox>
                                        </Col>
                                    )

                                })}
                            </Row>
                        </div>
                    )

                })}
            </Modal>
        )
    }

    componentDidMount(){

        // Only get the files with sub category
        const fileList = this.props.activeCategoryFeature.fileList.filter( _file => _file.category )

        q.all(
            fileList
            .map( _file => {

                return _postRetrieveTopBrandsFromCategory({
                    categoryKebabName: _file.category.titleUrl,
                    options: {
                        sub: _file.category.isSub
                    }
                })

            })
        )
        .then( resArr => {

            const categoriesWithTopBrands = []

            //Response array contains the responses of individual calls to top brands
            resArr.map( (res, index) => {

                categoriesWithTopBrands.push({
                    title: fileList[index].category.title,
                    topBrands: res.data.topBrands
                })
            })

            this.setState({
                categoriesWithTopBrands
            })
        })

    }

    handleCheck = ( brandObj ) => {

        const { brands } = this.props

        const includes = brands.filter( _brand => _brand.kebabName === brandObj.kebabName).length > 0

        if( includes ){

            this.props.setBrands(brands.filter( _brand => _brand.kebabName !== brandObj.kebabName ))

        } else {

            if( brands.length >= 7 ){
                return message.warning("You can only select up to 7 brands!")
            }

            this.props.setBrands([...brands, brandObj ])
        }

    }
}

export default connect(
    state => ({
        activeCategoryFeature: state.categoryFeatures.activeCategoryFeature,
        brands: state.categoryFeatures.activeCategoryFeature.brands || []
    }),
    dispatchEvent => ({
        setBrands: (brands) => dispatchEvent(setBrands(brands))
    })
)(BrandsSelectorModal)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/brands-selector/modal.js